import { useMemo } from 'react'

import { Modal } from 'Components/Modal/Modal'
import { ModalHeader } from 'Components/Modal/ModalHeader'

import { ModalType, usePeoplePageContext } from 'Contexts/PeoplePageContext'
import { useEmployerUsersContext } from 'Contexts/EmployerUsersContext'

import { AddPurchaseForUserForm } from 'Pages/JOONAdmin/PeoplePage/AddPurchaseForUserForm'

export const AddPurchaseForUserModal = () => {
  const {
    state: { modal, actionableUserId },
    setModal
  } = usePeoplePageContext()

  const {
    state: { users }
  } = useEmployerUsersContext()

  const user = useMemo(() => {
    return users.find((u) => u.id == actionableUserId)
  }, [users, actionableUserId])

  const setShowModal = (show: boolean) => setModal(show ? ModalType.AddPurchaseForUser : undefined)

  return (
    <Modal showModal={modal === ModalType.AddPurchaseForUser} setShowModal={setShowModal} overflow>
      <ModalHeader>
        Add Purchase for User {user?.id} ({user?.userInfo.email})
      </ModalHeader>
      <AddPurchaseForUserForm user={user} />
    </Modal>
  )
}
